export enum PermissionContract {
  NONE,
  CHECKED_NO_UPLOAD,
  CHECKED_WITH_UPLOAD
}
